import API from "../apiWrapper";
import { ReportOutput } from "../../enums/ReportOutput";
import { ICampusAttendanceReportParams } from "../../interfaces/attendance/ICampusAttendance";

export const GetCampusAttendanceData = (campusId: string, forDay: Date | null) => {
  return API()
    .get("/Attendance/CampusAttendance/GetCampusAttendance", {
      params: {
        campusId,
        forDay,
      },
    })
    .then(
      (res: any) => {
        if (res && res.data) {
          return res;
        }
      },
      (error: any) => {
        return error;
      }
    );
};

export const generateCampusAttendanceReport = (
  params: ICampusAttendanceReportParams,
  isPreview: boolean = false
) => {
  return API()
    .post("/Attendance/CampusAttendance/PrintCampusAttendance", params, {
      responseType: "blob",
    })
    .then(
      (res: any) => {
        if (res && res.data) {
          if (isPreview && ReportOutput.Pdf === params.exportType) {
            return res.data;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            let exportType: number = Number(params.exportType);
            let extension = "";
            switch (exportType) {
              case Number(ReportOutput.Pdf):
                extension = "pdf";
                break;
              case Number(ReportOutput.Excel):
                extension = "xls";
                break;
              case Number(ReportOutput.CSV):
                extension = "csv";
                break;
              default:
                extension = "pdf";
                break;
            }
            var fileName = "CampusAttendanceReport" + "." + extension;

            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          }
        }
      },
      (error: any) => {
        return null;
      }
    );
};
